import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface Make {
    _id: string;
    name: string;
}

interface MakesResponse {
    makes: Make[];
}

const getMakes = async (sessionId: string): Promise<MakesResponse> => {
    const { data } = await axios.get(`${API_URL}/makes`, {
        headers: {
            Authorization: sessionId
        }
    });
    return data;
};

export const useGetMakes = () => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/makes'],
        queryFn: () => getMakes(sessionContext?.sessionId ?? ''),
        enabled: !!sessionContext?.sessionId,
        staleTime: 60 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};

